import { IS_LAXMI_HOST } from './demo';

// Label for payments the company itself covered (AMP auto-pay). Laxmi's addresses keep Laxmi's exact text.
export const paidByLabel = (companyName) => `Paid by ${IS_LAXMI_HOST ? 'Laxmi Cable Vision' : (companyName || 'the company')}`;
